<script>
import ApplicantLink from './ApplicantLink.vue'
import BulkRecycleModal from './BulkRecycleModal.vue'
import BulkPassModal from './BulkPassModal.vue'

import { debounce } from 'lodash';

export default {
    components: {
        ApplicantLink,
        BulkRecycleModal,
        BulkPassModal
    },

    props: {
        requisition: {
            type: Object,
            required: true
        },
        jobs: {
            required: false,
            type: Array
        },
        csrfToken: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            selectedPhases: [],
            allPhases: [
                'loading_cv',
                'killer_questions',
                'language_proficiency',
                'telephonic_screening',
                'first_interview',
                'panel_interview',
                'skills_assessment',
                'background_verification',
                'loading_offer',
                'onboarding',
                'start',
            ],
            atsType: this.requisition.person_specification.ats_type,
            selectedApplications: [],
            bulkRecycle: false,
            bulkAction: '',
            showSpinner: false,
            currentPage: 1,
            hasMore: true,
            applicationsLoadingCv: [],
            applicantsDoingKillerQuestions: [],
            applicationsInLanguageProfPhase: [],
            applicantsInTelephonicScreeningPhase: [],
            applicantsInFirstInterviewPhase: [],
            applicantsInPanelInterviewPhase: [],
            applicantsInSkillsAssessmentPhase: [],
            applicantsInBackgroundVerificationPhase: [],
            applicantsInLoadingOfferPhase: [],
            applicantsInOnboardingPhase: [],
            applicantsInStartPhase: [],

            totalApplicationsLoadingCv: 0,
            totalApplicantsDoingKillerQuestions: 0,
            totalApplicationsInLanguageProfPhase: 0,
            totalApplicantsInTelephonicScreeningPhase: 0,
            totalApplicantsInFirstInterviewPhase: 0,
            totalApplicantsInPanelInterviewPhase: 0,
            totalApplicantsInSkillsAssessmentPhase: 0,
            totalApplicantsInBackgroundVerificationPhase: 0,
            totalApplicantsInLoadingOfferPhase: 0,
            totalApplicantsInOnboardingPhase: 0,
            totalApplicantsInStartPhase: 0,
            searchTerm: '',
            selectedMoveApplications: {
                loading_cv: [],
                killer_questions: [],
                language_proficiency: [],
                telephonic_screening: [],
                first_interview: [],
                panel_interview: [],
                skills_assessment: [],
                background_verification: [],
                loading_offer: [],
                onboarding: [],
                start: [],
            }
        }
    },

    beforeMount() {
        if (this.requisition.is_pipeline) {
            localStorage.removeItem('Requisitions.selectedPhases')
            this.allPhases = [
                'loading_cv',
                'killer_questions',
                'language_proficiency',
                'telephonic_screening',
                'first_interview',
                'panel_interview',
                'skills_assessment',
                'background_verification',
                'loading_offer',
            ]
        }

        if (this.atsType == 'leadership_and_support') {
            localStorage.removeItem('Requisitions.selectedPhases');
            this.allPhases = [
                'loading_cv',
                'killer_questions',
                'telephonic_screening',
                'first_interview',
                'background_verification',
                'skills_assessment',
                'panel_interview',
                'loading_offer',
                'onboarding',
                'start'
            ];

            if (this.requisition.is_pipeline) {
                localStorage.removeItem('Requisitions.selectedPhases')
                this.allPhases = [
                    'loading_cv',
                    'killer_questions',
                    'telephonic_screening',
                    'first_interview',
                    'background_verification',
                    'skills_assessment',
                    'panel_interview',
                    'loading_offer'
                ]
            }
        }
    },

    mounted() {
        const selectedPhases = localStorage.getItem('Requisitions.selectedPhases')
        this.selectedPhases = selectedPhases == null ? this.allPhases : JSON.parse(selectedPhases)

        this.loadPosts();
    },

    methods: {
        async loadPosts(clearResult = false) {
            this.showSpinner = true;
            try {
                const response = await fetch(`/ajax/get-requisition-applications/${this.requisition.id}?page=${this.currentPage}&searchTerm=${encodeURIComponent(this.searchTerm)}`);
                const data = await response.json();

                this.hasMore = data.has_more;

                this.totalApplicationsLoadingCv = data.applicationsLoadingCv.totalItems;
                this.totalApplicantsDoingKillerQuestions = data.applicantsDoingKillerQuestions.totalItems;
                this.totalApplicationsInLanguageProfPhase = data.applicationsInLanguageProfPhase.totalItems;
                this.totalApplicantsInTelephonicScreeningPhase = data.applicantsInTelephonicScreeningPhase.totalItems;
                this.totalApplicantsInFirstInterviewPhase = data.applicantsInFirstInterviewPhase.totalItems;
                this.totalApplicantsInLoadingOfferPhase = data.applicantsInLoadingOfferPhase.totalItems;
                this.totalApplicantsInPanelInterviewPhase = data.applicantsInPanelInterviewPhase.totalItems;
                this.totalApplicantsInSkillsAssessmentPhase = data.applicantsInSkillsAssessmentPhase.totalItems;
                this.totalApplicantsInBackgroundVerificationPhase = data.applicantsInBackgroundVerificationPhase.totalItems;
                this.totalApplicantsInOnboardingPhase = data.applicantsInOnboardingPhase.totalItems;
                this.totalApplicantsInStartPhase = data.applicantsInStartPhase.totalItems;

                if (clearResult) {
                    this.applicationsLoadingCv = data.applicationsLoadingCv.applications;
                    this.applicantsDoingKillerQuestions = data.applicantsDoingKillerQuestions.applications;
                    this.applicationsInLanguageProfPhase = data.applicationsInLanguageProfPhase.applications;
                    this.applicantsInTelephonicScreeningPhase = data.applicantsInTelephonicScreeningPhase.applications;
                    this.applicantsInFirstInterviewPhase = data.applicantsInFirstInterviewPhase.applications;
                    this.applicantsInLoadingOfferPhase = data.applicantsInLoadingOfferPhase.applications;
                    this.applicantsInPanelInterviewPhase = data.applicantsInPanelInterviewPhase.applications;
                    this.applicantsInSkillsAssessmentPhase = data.applicantsInSkillsAssessmentPhase.applications;
                    this.applicantsInBackgroundVerificationPhase = data.applicantsInBackgroundVerificationPhase.applications;
                    this.applicantsInOnboardingPhase = data.applicantsInOnboardingPhase.applications;
                    this.applicantsInStartPhase = data.applicantsInStartPhase.applications;
                } else {
                    this.applicationsLoadingCv = [...this.applicationsLoadingCv, ...data.applicationsLoadingCv.applications];
                    this.applicantsDoingKillerQuestions = [...this.applicantsDoingKillerQuestions, ...data.applicantsDoingKillerQuestions.applications];
                    this.applicationsInLanguageProfPhase = [...this.applicationsInLanguageProfPhase, ...data.applicationsInLanguageProfPhase.applications];
                    this.applicantsInTelephonicScreeningPhase = [...this.applicantsInTelephonicScreeningPhase, ...data.applicantsInTelephonicScreeningPhase.applications];
                    this.applicantsInFirstInterviewPhase = [...this.applicantsInFirstInterviewPhase, ...data.applicantsInFirstInterviewPhase.applications];
                    this.applicantsInLoadingOfferPhase = [...this.applicantsInLoadingOfferPhase, ...data.applicantsInLoadingOfferPhase.applications];
                    this.applicantsInPanelInterviewPhase = [...this.applicantsInPanelInterviewPhase, ...data.applicantsInPanelInterviewPhase.applications];
                    this.applicantsInSkillsAssessmentPhase = [...this.applicantsInSkillsAssessmentPhase, ...data.applicantsInSkillsAssessmentPhase.applications];
                    this.applicantsInBackgroundVerificationPhase = [...this.applicantsInBackgroundVerificationPhase, ...data.applicantsInBackgroundVerificationPhase.applications];
                    this.applicantsInOnboardingPhase = [...this.applicantsInOnboardingPhase, ...data.applicantsInOnboardingPhase.applications];
                    this.applicantsInStartPhase = [...this.applicantsInStartPhase, ...data.applicantsInStartPhase.applications];
                }
            } catch (error) {
                console.error('Error loading posts:', error);
            } finally {
                this.showSpinner = false;
            }
        },
        loadMore() {
            if (this.hasMore) {
                this.currentPage++;
                this.loadPosts();
            }
        },
        phasesChanged() {
            localStorage.setItem('Requisitions.selectedPhases', JSON.stringify(this.selectedPhases))
        },

        applicationsByPhase(phase) {
            if (phase === 'loading_cv') {
                return this.applicationsLoadingCv
            } else if (phase === 'killer_questions'){
                return this.applicantsDoingKillerQuestions
            } else if (phase === 'language_proficiency') {
                return this.applicationsInLanguageProfPhase
            } else if (phase === 'telephonic_screening') {
                return this.applicantsInTelephonicScreeningPhase
            } else if (phase === 'first_interview') {
                return this.applicantsInFirstInterviewPhase
            } else if (phase === 'panel_interview') {
                return this.applicantsInPanelInterviewPhase
            } else if (phase === 'skills_assessment') {
                return this.applicantsInSkillsAssessmentPhase
            } else if (phase === 'background_verification') {
                return this.applicantsInBackgroundVerificationPhase
            } else if (phase === 'loading_offer') {
                return this.applicantsInLoadingOfferPhase
            } else if (phase === 'onboarding') {
                return this.applicantsInOnboardingPhase
            } else if (phase === 'start') {
                return this.applicantsInStartPhase
            }
        },

        toTitleCase(str) {
            if (this.requisition.is_pipeline) {
                if (str == 'loading_offer') {
                    str = 'passed_background_verification';
                }
            }

            if (this.atsType == 'leadership_and_support') {
                if (str == 'telephonic_screening') {
                    str = 'telephonic_CV_screening';
                }

                if (str == 'skills_assessment') {
                    str = 'psychometric_assessment';
                }
                if (this.requisition.is_pipeline) {
                    if (str == 'loading_offer') {
                        str = 'passed_panel_interview';
                    }
                }
            }

            str = str.split('_').join(' ');
            console.log(str);
            return str.replace(/\b\w/g, function (word) {
                return word.toUpperCase();
            });
        },

        toggleModal(ref) {
            this.$refs[ref].toggleModal()
        },

        /**
         * 
         * @param string phaseName 
         * @param boolean checked 
         */
        selectAllInPhase(phaseName, event) {
            const checked = event.target.checked;
            const applications = this.applicationsByPhase(phaseName);
            if (applications) {
                for (const application of applications) {
                    console.log(application.id);
                    if (checked) {
                        this.addSelectedUser(application.id, phaseName);
                    } else {
                        this.removeSelectedUser(application.id, phaseName)
                    }
                }
            }
        },

        updateSelectedApplication(selectedApplication) {
            if (selectedApplication.checked) {
                this.addSelectedUser(selectedApplication.id, selectedApplication.phase)
            } else {
                this.removeSelectedUser(selectedApplication.id, selectedApplication.phase)
            }
        },

        addSelectedUser(id, phase = '') {
            id = parseInt(id)
            if (!this.selectedApplications.includes(id)) {
                this.selectedApplications.push(id);
            }

            if (!this.selectedMoveApplications[phase].includes(id)) {
                this.selectedMoveApplications[phase].push(id);
            }
        },

        removeSelectedUser(id, phase = '') {
            id = parseInt(id)

            this.selectedApplications = this.selectedApplications.filter(selectedApplicationId => selectedApplicationId !== id);
            this.selectedMoveApplications[phase] = this.selectedMoveApplications[phase].filter(selectedApplicationId => selectedApplicationId !== id);
        },

        handleInput() {
            clearTimeout(this.typingTimeout);
            this.typingTimeout = setTimeout(this.fetchData, 500);
        },
        fetchData() {
            this.currentPage = 1;
            this.loadPosts(true)
        },
    },
    watch: {
        bulkRecycle: {
            handler: function (newVal, oldVal) {
                if (newVal) {
                    this.selectedApplications = [];
                }
            },
            deep: true
        }
    }
}
</script>

<template>
    <div class="requisitions-applicants grid-x grid-padding-x grid-padding-y">
        <div class="cell medium-3">
            <label class="filter-label">Filter Applicants</label>
            <div class="search-box">
                <input class="long-placeholder" type="text" placeholder="Search candidate (name, surname, ID, etc.)" v-model="searchTerm" @input="handleInput"/>
                <input class="short-placeholder" type="text" placeholder="Search candidate" v-model="searchTerm" @input="handleInput"/>
                <i class="fa fa-solid fa-search icon"></i>
            </div>
            <div class="spinner" v-if="showSpinner">
                <i class="fa fa-solid fa-spinner fa-spin"></i> Loading....
            </div>
        </div>

        <div class="cell medium-9 top-margin">
            <label v-for="phase in allPhases" class="phase" :key="phase.id">
                <div class="checkbox-group">
                    {{ phase == 'loading_cv' ? 'Loading CV' : toTitleCase(phase) }}
                    <input type="checkbox" :value="phase" v-model="selectedPhases" @change="phasesChanged"/>
                    <span class="check-mark"></span>
                </div>
            </label>
        </div>
        <div class="small-12 mb-2">
            <div class="grid-x grid-padding-x grid-padding-y">
                <div class="cell medium-1" v-if="hasMore">
                    <button class="btn btn-success mycalling-green" @click="loadMore" :disabled="showSpinner">
                        Load More
                    </button>
                </div>

                <div class="cell medium-2">
                    <div class="grid-x grid-padding-x grid-padding-y align-middle">
                        <div class="cell shrink">Bulk action: </div>
                        <div class="cell auto">
                            <select v-model="bulkAction">
                                <option value="">Select</option>
                                <option value="recycle">Recycle</option>
                                <option value="passed">Passed</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div v-if="bulkAction == 'recycle'" class="cell medium-3 recycle-info-container">
                    <div>{{ selectedApplications.length }} selected</div>
                    <button :disabled="(selectedApplications.length <= 0)" class="button recycle px-5 ml-10" type="button" @click="toggleModal('bulkRecycleModal')">RECYCLE</button>
                </div>
            </div>
        </div>

        <div class="small-12">
            <div class="table-responsive">
                <table class="mb-4 table table-fixed">
                <thead>
                    <tr class="table-head">
                        <th v-if="selectedPhases.includes('loading_cv')" class="border-head">
                            Loading CV<br/>({{ applicationsLoadingCv.length }} of {{ totalApplicationsLoadingCv }})
                            <div v-if="bulkAction === 'recycle'" class="select-all-in-phase">
                                <input type="checkbox" title="Select all candidates" @change="selectAllInPhase('loading_cv', $event)"/>
                            </div>

                            <!-- Temporary commented as client requested to pending this feature -->
                            <!-- <div v-if="selectedMoveApplications['loading_cv'].length > 0 && bulkAction == 'passed'" class="selected-count">
                                <button class="btn btn-success mycalling-green w-100" @click="toggleModal('passLoadingCvModal')">Pass</button>
                            </div>

                            <bulk-pass-modal
                                ref="passLoadingCvModal"
                                :csrfToken="csrfToken"
                                :job-applications="selectedMoveApplications['loading_cv']"
                                phase-name="Loading CV"
                                phase="loading_cv"
                            /> -->
                        </th>
                        <th v-if="selectedPhases.includes('killer_questions')" class="border-head">
                            Killer Questions<br/>({{ applicantsDoingKillerQuestions.length }} of {{ totalApplicantsDoingKillerQuestions }})
                            <div v-if="bulkAction === 'recycle'" class="select-all-in-phase">
                                <input type="checkbox" title="Select all candidates" @change="selectAllInPhase('killer_questions', $event)"/>
                            </div>

                            <!-- Temporary commented as client requested to pending this feature -->
                            <!-- <div v-if="selectedMoveApplications['killer_questions'].length > 0 && bulkAction == 'passed'" class="selected-count">
                                <button class="btn btn-success mycalling-green w-100" @click="toggleModal('passKillerQuestionModal')">Pass</button>
                            </div>

                            <bulk-pass-modal
                                ref="passKillerQuestionModal"
                                :csrfToken="csrfToken"
                                :job-applications="selectedMoveApplications['killer_questions']"
                                phase-name="Killer Question"
                                phase="killer_questions"
                            /> -->
                        </th>
                        <th v-if="selectedPhases.includes('language_proficiency')" class="border-head">
                            Language Proficiency<br/>({{ applicationsInLanguageProfPhase.length }} of {{ totalApplicationsInLanguageProfPhase }})
                            <div v-if="bulkAction === 'recycle'" class="select-all-in-phase">
                                <input type="checkbox" title="Select all candidates" @change="selectAllInPhase('language_proficiency', $event)"/>
                            </div>

                            <!-- Temporary commented as client requested to pending this feature -->
                            <!-- <div v-if="selectedMoveApplications['language_proficiency'].length > 0 && bulkAction == 'passed'" class="selected-count">
                                <button class="btn btn-success mycalling-green w-100" @click="toggleModal('passLanguageProficiencyModal')">Pass</button>
                            </div>

                            <bulk-pass-modal
                                ref="passLanguageProficiencyModal"
                                :csrfToken="csrfToken"
                                :job-applications="selectedMoveApplications['language_proficiency']"
                                phase-name="Language Proficiency"
                                phase="language_proficiency"
                            /> -->

                        </th>
                        <th v-if="selectedPhases.includes('telephonic_screening')" class="border-head">
                            <span v-if="atsType == 'leadership_and_support'">Telephonic CV Screening</span>
                            <span v-else>Telephonic Screening</span><br/>
                            ({{ applicantsInTelephonicScreeningPhase.length }} of {{ totalApplicantsInTelephonicScreeningPhase }})

                            <div v-if="bulkAction === 'recycle'" class="select-all-in-phase">
                                <input type="checkbox" title="Select all candidates" @change="selectAllInPhase('telephonic_screening', $event)"/>
                            </div>

                            <!-- Temporary commented as client requested to pending this feature -->
                            <!-- <div v-if="selectedMoveApplications['telephonic_screening'].length > 0 && bulkAction == 'passed'" class="selected-count">
                                <button class="btn btn-success mycalling-green w-100" @click="toggleModal('passTelephonicScreeningModal')">Pass</button>
                            </div>

                            <bulk-pass-modal
                                ref="passTelephonicScreeningModal"
                                :csrfToken="csrfToken"
                                :job-applications="selectedMoveApplications['telephonic_screening']"
                                phase-name="Telephonic Screening"
                                phase="telephonic_screening"
                            /> -->
                        </th>
                        <th v-if="selectedPhases.includes('first_interview')" class="border-head">
                            First Interview<br/>({{ applicantsInFirstInterviewPhase.length }} of {{ totalApplicantsInFirstInterviewPhase }})

                            <div v-if="bulkAction === 'recycle'" class="select-all-in-phase">
                                <input type="checkbox" title="Select all candidates" @change="selectAllInPhase('first_interview', $event)"/>
                            </div>

                            <!-- Temporary commented as client requested to pending this feature -->
                            <!-- <div v-if="selectedMoveApplications['first_interview'].length > 0 && bulkAction == 'passed'" class="selected-count">
                                <button class="btn btn-success mycalling-green w-100" @click="toggleModal('passFirstInterviewModal')">Pass</button>
                            </div>

                            <bulk-pass-modal
                                ref="passFirstInterviewModal"
                                :csrfToken="csrfToken"
                                :job-applications="selectedMoveApplications['first_interview']"
                                phase-name="First Interview"
                                phase="first_interview"
                            /> -->
                        </th>
                        <th v-if="selectedPhases.includes('background_verification') && atsType == 'leadership_and_support'" class="border-head">
                            Background Verification<br/>({{ applicantsInBackgroundVerificationPhase.length }} of {{ totalApplicantsInBackgroundVerificationPhase }})

                            <div v-if="bulkAction === 'recycle'" class="select-all-in-phase">
                                <input type="checkbox" title="Select all candidates" @change="selectAllInPhase('background_verification', $event)"/>
                            </div>

                            <!-- Temporary commented as client requested to pending this feature -->
                            <!-- <div v-if="selectedMoveApplications['background_verification'].length > 0 && bulkAction == 'passed'" class="selected-count">
                                <button class="btn btn-success mycalling-green w-100" @click="toggleModal('passBackgroundVerificationModal')">Pass</button>
                            </div>

                            <bulk-pass-modal
                                ref="passBackgroundVerificationModal"
                                :csrfToken="csrfToken"
                                :job-applications="selectedMoveApplications['background_verification']"
                                phase-name="Background Verification"
                                phase="background_verification"
                            /> -->
                        </th>
                        <th v-if="selectedPhases.includes('skills_assessment')" class="border-head">
                            <span v-if="atsType == 'leadership_and_support'">Psychometric Assessment</span>
                            <span v-else>Skills Assessment</span><br/>
                            ({{ applicantsInSkillsAssessmentPhase.length }} of {{ totalApplicantsInSkillsAssessmentPhase }})

                            <div v-if="bulkAction === 'recycle'" class="select-all-in-phase">
                                <input type="checkbox" title="Select all candidates" @change="selectAllInPhase('skill_assessment', $event)"/>
                            </div>

                            <!-- Temporary commented as client requested to pending this feature -->
                            <!-- <div v-if="selectedMoveApplications['skills_assessment'].length > 0 && bulkAction == 'passed'" class="selected-count">
                                <button class="btn btn-success mycalling-green w-100" @click="toggleModal('passSkillAssessmentModal')">Pass</button>
                            </div>

                            <bulk-pass-modal
                                ref="passSkillAssessmentModal"
                                :csrfToken="csrfToken"
                                :job-applications="selectedMoveApplications['skills_assessment']"
                                :phase-name="`${atsType == 'leadership_and_support' ? 'Psychometric Assessment' : 'Skills Assessment'}`"
                                phase="skills_assessment"
                            /> -->

                        </th>
                        <th v-if="selectedPhases.includes('panel_interview')" class="border-head">
                            Panel Interview<br/>({{ applicantsInPanelInterviewPhase.length }} of {{ totalApplicantsInPanelInterviewPhase }})

                            <div v-if="bulkAction === 'recycle'" class="select-all-in-phase">
                                <input type="checkbox" title="Select all candidates" @change="selectAllInPhase('panel_interview', $event)"/>
                            </div>

                            <!-- Temporary commented as client requested to pending this feature -->
                            <!-- <div v-if="selectedMoveApplications['panel_interview'].length > 0 && bulkAction == 'passed'" class="selected-count">
                                <button class="btn btn-success mycalling-green w-100" @click="toggleModal('passPanelInterviewModal')">Pass</button>
                            </div>

                            <bulk-pass-modal
                                ref="passPanelInterviewModal"
                                :csrfToken="csrfToken"
                                :job-applications="selectedMoveApplications['panel_interview']"
                                phase-name="Panel Interview"
                                phase="panel_interview"
                            /> -->
                        </th>
                        <th v-if="selectedPhases.includes('background_verification') && atsType != 'leadership_and_support'" class="border-head">
                            Background Verification<br/>({{ applicantsInBackgroundVerificationPhase.length }} of {{ totalApplicantsInBackgroundVerificationPhase }})

                            <div v-if="bulkAction === 'recycle'" class="select-all-in-phase">
                                <input type="checkbox" title="Select all candidates" @change="selectAllInPhase('background_verification', $event)"/>
                            </div>

                            <!-- Temporary commented as client requested to pending this feature -->
                            <!-- <div v-if="selectedMoveApplications['background_verification'].length > 0 && bulkAction == 'passed'" class="selected-count">
                                <button class="btn btn-success mycalling-green w-100" @click="toggleModal('passBackgroundVerificationModal')">Pass</button>
                            </div>

                            <bulk-pass-modal
                                ref="passBackgroundVerificationModal"
                                :csrfToken="csrfToken"
                                :job-applications="selectedMoveApplications['background_verification']"
                                phase-name="Background Verification"
                                phase="background_verification"
                            /> -->
                        </th>
                        <th v-if="selectedPhases.includes('loading_offer')" class="border-head">
                            <span v-if="atsType === 'leadership_and_support'">
                                <span v-if="requisition.is_pipeline">Passed Panel Interview</span>
                                <span v-else>Loading Offer</span>
                            </span>
                            <span v-else>
                                <span v-if="requisition.is_pipeline">Passed Background Verification</span>
                                <span v-else>Loading Offer</span>
                            </span>
                            ({{ applicantsInLoadingOfferPhase.length }} of {{ totalApplicantsInLoadingOfferPhase }})

                            <div v-if="bulkAction != ''" class="select-all-in-phase">
                                <input type="checkbox" title="Select all candidates" @change="selectAllInPhase('loading_offer', $event)"/>
                            </div>

                            <div v-if="selectedMoveApplications['loading_offer'].length > 0 && bulkAction == 'passed'" class="selected-count">
                                <button class="btn btn-success mycalling-green w-100" @click="toggleModal('passLoadingOfferModal')">Pass</button>
                            </div>

                            <bulk-pass-modal
                                ref="passLoadingOfferModal"
                                :csrfToken="csrfToken"
                                :job-applications="selectedMoveApplications['loading_offer']"
                                phase-name="Loading Offer"
                                phase="loading_offer"
                            />
                        </th>
                        <th v-if="selectedPhases.includes('onboarding')" class="border-head">
                            Onboarding<br/>({{ applicantsInOnboardingPhase.length }} of {{ totalApplicantsInOnboardingPhase }})

                            <div v-if="bulkAction != ''" class="select-all-in-phase">
                                <input type="checkbox" title="Select all candidates" @change="selectAllInPhase('onboarding', $event)"/>
                            </div>

                            <div v-if="selectedMoveApplications['onboarding'].length > 0 && bulkAction == 'passed'" class="selected-count">
                                <button class="btn btn-success mycalling-green w-100" @click="toggleModal('passOnBoardingModal')">Pass</button>
                            </div>

                            <bulk-pass-modal
                                ref="passOnBoardingModal"
                                :csrfToken="csrfToken"
                                :job-applications="selectedMoveApplications['onboarding']"
                                phase-name="Onboarding"
                                phase="onboarding"
                            />
                        </th>
                        <th v-if="selectedPhases.includes('start')" class="border-head">
                            Start<br/>({{ applicantsInStartPhase.length }} of {{ totalApplicantsInStartPhase }})

                            <div v-if="bulkAction != ''" class="select-all-in-phase">
                                <input type="checkbox" title="Select all candidates" @change="selectAllInPhase('start', $event)"/>
                            </div>
                        </th>
                    </tr>
                </thead>

                <tbody>
                    <tr>
                        <td v-if="selectedPhases.includes('loading_cv')" class="align-top border-data">
                            <applicant-link v-for="jobApplication in applicationsLoadingCv"
                                :key="jobApplication.id"
                                :job-application="jobApplication"
                                :requisition="requisition"
                                phase="loading_cv"
                                :selected-applications="selectedMoveApplications['loading_cv']"
                                :bulk-recycle="bulkAction"
                                @update-selected-applications="updateSelectedApplication"
                            />
                        </td>
                        <td v-if="selectedPhases.includes('killer_questions')" class="align-top border-data">
                            <applicant-link v-for="jobApplication in applicantsDoingKillerQuestions"
                                :key="jobApplication.id"
                                :job-application="jobApplication"
                                :requisition="requisition"
                                phase="killer_questions"
                                :selected-applications="selectedApplications"
                                :bulk-recycle="bulkAction"
                                @update-selected-applications="updateSelectedApplication"
                            />
                        </td>
                        <td v-if="selectedPhases.includes('language_proficiency')" class="align-top border-data">
                            <applicant-link v-for="jobApplication in applicationsInLanguageProfPhase"
                                :key="jobApplication.id"
                                :job-application="jobApplication"
                                :requisition="requisition"
                                phase="language_proficiency"
                                :selected-applications="selectedApplications"
                                :bulk-recycle="bulkAction"
                                @update-selected-applications="updateSelectedApplication"
                            />
                        </td>
                        <td v-if="selectedPhases.includes('telephonic_screening')" class="align-top border-data">
                            <applicant-link v-for="jobApplication in applicantsInTelephonicScreeningPhase"
                                :key="jobApplication.id"
                                :job-application="jobApplication"
                                :requisition="requisition"
                                phase="telephonic_screening"
                                :selected-applications="selectedApplications"
                                :bulk-recycle="bulkAction"
                                @update-selected-applications="updateSelectedApplication"
                            />
                        </td>
                        <td v-if="selectedPhases.includes('first_interview')" class="align-top border-data">
                            <applicant-link v-for="jobApplication in applicantsInFirstInterviewPhase"
                                :key="jobApplication.id"
                                :job-application="jobApplication"
                                :requisition="requisition"
                                phase="first_interview"
                                :selected-applications="selectedApplications"
                                :bulk-recycle="bulkAction"
                                @update-selected-applications="updateSelectedApplication"
                            />
                        </td>
                        <td v-if="selectedPhases.includes('background_verification') && atsType == 'leadership_and_support'" class="align-top border-data">
                            <applicant-link v-for="jobApplication in applicantsInBackgroundVerificationPhase"
                                :key="jobApplication.id"
                                :job-application="jobApplication"
                                :requisition="requisition"
                                phase="background_verification"
                                :selected-applications="selectedApplications"
                                :bulk-recycle="bulkAction"
                                @update-selected-applications="updateSelectedApplication"
                            />
                        </td>
                        <td v-if="selectedPhases.includes('skills_assessment')" class="align-top border-data">
                            <applicant-link v-for="jobApplication in applicantsInSkillsAssessmentPhase"
                                :key="jobApplication.id"
                                :job-application="jobApplication"
                                :requisition="requisition"
                                phase="skills_assessment"
                                :selected-applications="selectedApplications"
                                :bulk-recycle="bulkAction"
                                @update-selected-applications="updateSelectedApplication"
                            />
                        </td>
                        <td v-if="selectedPhases.includes('panel_interview')" class="align-top border-data">
                            <applicant-link v-for="jobApplication in applicantsInPanelInterviewPhase"
                                :key="jobApplication.id"
                                :job-application="jobApplication"
                                :requisition="requisition"
                                phase="panel_interview"
                                :selected-applications="selectedApplications"
                                :bulk-recycle="bulkAction"
                                @update-selected-applications="updateSelectedApplication"
                            />
                        </td>
                        <td v-if="selectedPhases.includes('background_verification') && atsType != 'leadership_and_support'" class="align-top border-data">
                            <applicant-link v-for="jobApplication in applicantsInBackgroundVerificationPhase"
                                :key="jobApplication.id"
                                :job-application="jobApplication"
                                :requisition="requisition"
                                phase="background_verification"
                                :selected-applications="selectedApplications"
                                :bulk-recycle="bulkAction"
                                @update-selected-applications="updateSelectedApplication"
                            />
                        </td>
                        <td v-if="selectedPhases.includes('loading_offer')" class="align-top border-data">
                            <applicant-link v-for="jobApplication in applicantsInLoadingOfferPhase"
                                :key="jobApplication.id"
                                :job-application="jobApplication"
                                :requisition="requisition"
                                phase="loading_offer"
                                :selected-applications="selectedApplications"
                                :bulk-recycle="bulkAction"
                                @update-selected-applications="updateSelectedApplication"
                            />
                        </td>
                        <td v-if="selectedPhases.includes('onboarding')" class="align-top border-data">
                            <applicant-link v-for="jobApplication in applicantsInOnboardingPhase"
                                :key="jobApplication.id"
                                :job-application="jobApplication"
                                :requisition="requisition"
                                phase="onboarding"
                                :selected-applications="selectedApplications"
                                :bulk-recycle="bulkAction"
                                @update-selected-applications="updateSelectedApplication"
                            />
                        </td>
                        <td v-if="selectedPhases.includes('start')" class="align-top border-data">
                            <applicant-link v-for="jobApplication in applicantsInStartPhase"
                                :key="jobApplication.id"
                                :job-application="jobApplication"
                                :requisition="requisition"
                                phase="start"
                                :selected-applications="selectedApplications"
                                :bulk-recycle="bulkAction=='recycle'?'recycle':''"
                                @update-selected-applications="updateSelectedApplication"
                            />
                        </td>
                    </tr>
                </tbody>
            </table>
            </div>

            <button class="btn btn-success mycalling-green" @click="loadMore" v-if="hasMore" :disabled="showSpinner">
                Load More
            </button>
        </div>


        <bulk-recycle-modal
            ref="bulkRecycleModal"
            :csrfToken="csrfToken"
            :job-applications="selectedApplications"
            :job-application="requisition"
        />
    </div>
</template>